<template>
    <div style="display: inline-block;">
        <SplitButton :label="label" :icon="icon" @click="onClick" :model="items"
        :class="[
            type ? 'p-button-' + type : ''
        ]"></SplitButton>
    </div>
</template>

<script>
import SplitButton from 'primevue/splitbutton';
import { computed } from 'vue';

export default {
    name: 'tw-splitbutton',
    components: {
        SplitButton
    },
    props: {
        label: {
            type: String,
            default: '下拉按钮'
        },
        icon: {
            type: String,
            default: ''
        },
        type: {
            // '','secondary','success','info','warning','help','danger','text'
            default: null
        },
        // 下拉项（用于绑定变量）
        menus: {
            type: Array,
            default: function() {
                return [
                    // { label: '示范按钮', icon: 'pi pi-external-link' }
                ]
            }
        },
        // 下拉项（使用设计器动态属性添加项）
        model: {
            type: Array,
            default: function() {
                return [
                    // { label: '示范按钮', icon: 'pi pi-external-link' }
                ]
            }
        }
    },
    setup(props, context) {

        const command = function(item) {
            context.emit('command', item)
        }

        const onClick = function(event) {
            context.emit('btn-click', event)
        }

        const items = computed(() => {
            const items1 = props.menus?.map(el => {
                return Object.assign({}, el, { 
                    command: () => { command(el) }
                })
            }) ?? []
            const items2 = props.model?.map(el => {
                return Object.assign({}, el, { 
                    command: () => { command(el) }
                })
            }) ?? []

            return [...items1, ...items2]
        })

        return {
            items,
            onClick
        }
    }
}
</script>